import { API_BASE } from '@/utils/api-url'

async function request(path, options = {}) {
  const token = localStorage.getItem('dzzj_website_token')
  const { headers: optionHeaders = {}, ...requestOptions } = options
  const response = await fetch(`${API_BASE}${path}`, {
    ...requestOptions,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...optionHeaders
    }
  })
  const result = await response.json()
  if (response.status === 424 || result.code === 424) {
    if (token) {
      localStorage.removeItem('dzzj_website_token')
      localStorage.removeItem('dzzj_website_refresh_token')
      window.dispatchEvent(new CustomEvent('website-auth-expired'))
      throw new Error('登录已失效，请重新登录')
    }
    throw new Error(result.msg || '接口请求失败')
  }
  if (!response.ok || result.code !== 0) {
    throw new Error(result.msg || '接口请求失败')
  }
  return result.data
}

export function createWebsiteOrder(data, idempotencyKey) {
  return request('/trade/website/orders', {
    method: 'POST',
    headers: {
      'Idempotency-Key': idempotencyKey
    },
    body: JSON.stringify(data)
  })
}

export function reviseWebsiteOrder(id, data) {
  return request(`/trade/website/orders/${id}/revision`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export function getWebsiteProductConfig() {
  return request('/trade/website/product-config')
}

export function getWebsiteOrders() {
  return request('/trade/website/orders')
}

export function getWebsiteOrder(id) {
  const orderId = String(id || '').trim()
  if (!/^\d+$/.test(orderId)) {
    return Promise.reject(new Error('订单ID无效'))
  }
  return request(`/trade/website/orders/${orderId}`)
}

export function createWebsiteAlipayPay(id, terminal) {
  return request(`/trade/website/orders/${id}/pay`, {
    method: 'POST',
    body: JSON.stringify({ terminal })
  })
}

export function submitWebsiteBankTransfer(id, terminal) {
  return request(`/trade/website/orders/${id}/bank-transfer/submit`, {
    method: 'POST',
    body: JSON.stringify({ terminal })
  })
}

export function cancelWebsiteOrder(id) {
  return request(`/trade/website/orders/${id}/cancel`, {
    method: 'PUT'
  })
}

export function confirmWebsiteReceipt(id) {
  return request(`/trade/website/orders/${id}/receipt`, {
    method: 'PUT'
  })
}

export function getWebsiteAddresses() {
  return request('/trade/website/addresses')
}

export function deleteWebsiteAddress(id) {
  return request(`/trade/website/addresses/${id}`, {
    method: 'DELETE'
  })
}
